export default "/img/v12-0-0_fig6.83050eafe51b2bbf65f1f8147a981544.png";